
const FARBNAMEN = {
    schwarz: "#000000",
    weiß: "#FFFFFF",
    rot: "#FF0000",
    grün: "#008000",
    blau: "#0000FF",
    gelb: "#FFFF00",
    lila: "#800080",
    orange: "#FFA500",
    pink: "#FFC0CB",
    braun: "#A52A2A",
    grau: "#808080",
    türkis: "#40E0D0",
    violett: "#8A2BE2",
    gold: "#FFD700",
    silber: "#C0C0C0"
};
  
export function stringToColor(farbe) {
    if (typeof farbe !== 'string') 
        return null;

    const farbeKlein = farbe.toLowerCase();
    
    return FARBNAMEN[farbeKlein] || null;
}